<div class="card">
	<div class="card-header mm-card-header">
		Sites
	</div>
	<div class="card-body">
		<div class="d-flex justify-content-between">
			<mmoga-organization-site-filter (filterRequestEvent)="onFilter($event)"></mmoga-organization-site-filter>
			<mmoga-organization-site-search (searchTermEvent)="onSearch($event)"></mmoga-organization-site-search>
		</div>
		<mmoga-organization-site-table [searchFilterObs]="searchFilter$"
		                               [searchTermObs]="searchTerm$"></mmoga-organization-site-table>
	</div>
</div>
